/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CreditorInstitution } from "./CreditorInstitution";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const CreditorInstitutionsR = t.interface({
  creditor_institutions: t.readonlyArray(
    CreditorInstitution,
    "array of CreditorInstitution"
  ),

  page_info: PageInfo
});

// optional attributes
const CreditorInstitutionsO = t.partial({});

export const CreditorInstitutions = t.intersection(
  [CreditorInstitutionsR, CreditorInstitutionsO],
  "CreditorInstitutions"
);

export type CreditorInstitutions = t.TypeOf<typeof CreditorInstitutions>;
